import { ElementDetailsAction } from "models/Resources/ElementDetailsResource";
import { useState } from "react";
import clsx from "clsx";
import ConfirmAction from "./ConfirmAction";
import "./DetailsAction.scss";

export type DetailsActionProps = {
  elementAction: ElementDetailsAction;
  onActionClick: (actionType: string) => void;
};

const DetailsAction: React.FC<DetailsActionProps> = ({
  elementAction,
  onActionClick,
}) => {
  const isActionAuthorized = elementAction.autorise;
  const isActionAvailable = elementAction.disponible;
  const actionType = elementAction.type;
  const buttonLabel = elementAction.etiquette;
  const [isButtonActive] = useState(isActionAuthorized && isActionAvailable);
  const [isConfirmActionDialogOpen, setIsConfirmedWindowOpen] = useState(false);

  function handleActionConfirmed(isConfirmed: boolean): void {
    if (isConfirmed) {
      onActionClick(elementAction.type);
    }
    setIsConfirmedWindowOpen(false);
  }

  return (
    <>
      <button
        className={createActionButtonClassName(
          isActionAuthorized,
          isActionAvailable,
          actionType,
          buttonLabel
        )}
        disabled={!isButtonActive}
        onClick={() => setIsConfirmedWindowOpen(true)}>
        {elementAction.etiquette}
      </button>
      {isConfirmActionDialogOpen ? (
        <ConfirmAction
          elementAction={elementAction}
          onActionConfirm={handleActionConfirmed}
          isOpen={isConfirmActionDialogOpen}
        />
      ) : null}
    </>
  );
};
export default DetailsAction;

function createActionButtonClassName(
  isAuthorized: boolean,
  isAvailable: boolean,
  type: string,
  label: string
): string {
  return clsx(
    "action-detail-button",
    label,
    isAuthorized && "authorized",
    isAvailable && "available",
    type
  );
}
